import React from "react";
import { Grid, FormControl, FormControlLabel, Switch, Typography, Box } from "@mui/material";
import * as Api from "../../../api";
import SelectizeTextField from "../../../components/SelectizeTextField";

const MultiLanguageTab = ({ data, handleChange, sectionName, errors }) => {
  // Get supported languages directly from API (static data)
  const supportedLanguages = Api.getSupportedLanguages().filter(lang => lang.code !== "en");

  const handleSwitchChange = (event) => {
    const { name, checked } = event.target;
    handleChange(sectionName, name, checked);
  };

  const handleLanguageChange = (selectedLanguages) => {
    // Extract language codes from selected options
    const languageCodes = selectedLanguages.map(lang => lang.value);
    handleChange(sectionName, "languages", languageCodes);
  };

  // Transform supported languages for SelectizeTextField
  const languageOptions = supportedLanguages.map(lang => ({
    label: lang.name || lang.code,
    value: lang.code,
    ...lang
  }));

  // Transform selected languages to match SelectizeTextField format
  const selectedLanguageOptions = data.languages?.map(langCode => {
    const foundLang = supportedLanguages.find(lang => lang.code === langCode);
    return foundLang ? {
      label: foundLang.name || foundLang.code,
      value: foundLang.code,
      ...foundLang
    } : { label: langCode, value: langCode };
  }) || [];

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Typography variant="h6" sx={{ mb: 2, fontFamily: "GilroySemiBold" }}>
          Multi-Language Configuration
        </Typography>
      </Grid>

      <Grid item xs={12} md={6}>
        <FormControl fullWidth>
          <FormControlLabel
            control={
              <Switch
                name="isEnabled"
                checked={data.isEnabled || false}
                onChange={handleSwitchChange}
                color="primary"
              />
            }
            label={
              <Box>
                <Typography variant="body1" sx={{ fontFamily: "GilroyMedium" }}>
                  Enable Multi-Language Support
                </Typography>
                <Typography variant="body2" color="textSecondary" sx={{ fontSize: "0.875rem" }}>
                  Toggle to enable multi-language support for the restaurant
                </Typography>
              </Box>
            }
            sx={{ alignItems: "flex-start" }}
          />
        </FormControl>
      </Grid>

      {data.isEnabled && (
        <Grid item xs={12} md={6}>
          <FormControl fullWidth>
            <Typography variant="body1" sx={{ mb: 1, fontFamily: "GilroyMedium" }}>
              Supported Languages
            </Typography>
            <Typography variant="body2" color="textSecondary" sx={{ mb: 2, fontSize: "0.875rem" }}>
              Select the languages you want to support
            </Typography>
            
            <Box sx={{ p: .75, border: "1px solid #e0e0e0", borderRadius: 1, backgroundColor: "#fff" }}>
              <SelectizeTextField
                value={selectedLanguageOptions}
                onChange={handleLanguageChange}
                options={languageOptions}
                placeholder="Select languages"
                isMulti={true}
                isSearchable={true}
                noOptionsMessage={() => "No languages available"}
                error={errors?.get("languages")}
                helperText={errors?.get("languages")}
              />
            </Box>
          </FormControl>
        </Grid>
      )}

      {data.isEnabled && data.languages?.length > 0 && (
        <Grid item xs={12}>
          <Box sx={{ p: 2, backgroundColor: "#f5f5f5", borderRadius: 1 }}>
            <Typography variant="body2" color="textSecondary">
              <strong>Note:</strong> After enabling multi-language support, you'll be able to translate menu items 
              and other content for the selected languages. The translation features will become available 
              in the menu management sections.
            </Typography>
          </Box>
        </Grid>
      )}
    </Grid>
  );
};

export default MultiLanguageTab;
